// ============================================================================
// TextField.jsx — Corelia v1.2 (FormLayout + thème unifié)
// ============================================================================
import React from "react";
import theme from "../../../styles/theme";
import FormLayout from "../../reusable/Forms/FormLayout";

const TextField = ({
  label,
  required = false, 
  labelPosition = "left",    // "left" | "top"
  labelWidth = null,
  align = "center",
  value,
  onChange,
  placeholder = "",
  disabled = false,
  error = null,
  width = "100%",
  style = {},
  inputStyle = {},
}) => {
  return (
    <FormLayout
      label={
        <>
          {label}
          {required && (
            <span style={{ color: theme.colors.text.required, marginLeft: 4 }}>
              *
            </span>
          )}
        </>
      }
      labelPosition={labelPosition}
      labelWidth={labelWidth}
      align={align}
      width={width}
      style={style}
    >
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        style={{
          width: "100%",
          minHeight: "22px",
          padding: "4px 6px 4px 6px",         
          fontFamily: theme.DT.font.primary,
          fontSize: theme.DT.fontSize.lg,
          fontWeight: theme.form.field.fontWeight,
          color: theme.form.field.color,
          margin:"0",

          borderRadius: theme.form.field.borderRadius,
          border: theme.form.field.border,
          // backgroundColor: disabled
          //   ? theme.form.disabled.background
          //   : theme.form.field.background,

          outline: "none",
          transition: theme.form.field.transition,
          boxSizing: "border-box",

          ...(disabled
            ? { color: theme.form.disabled.color, cursor: "not-allowed" }
            : {}),

          ...(error
            ? { borderColor: theme.colors.text.danger }
            : {}),

          ...inputStyle,
        }}
        onFocus={(e) => {
          if (!disabled) {
            e.target.style.borderColor = theme.form.focus.borderColor;
            e.target.style.boxShadow = theme.form.focus.boxShadow;
          }
        }}
        onBlur={(e) => {
          e.target.style.borderColor = error
            ? theme.colors.text.danger
            : theme.form.field.border.replace("1px solid ", "");
          e.target.style.boxShadow = "none";
        }}
      />

      {/* Message d’erreur */}
      {error && (
        <div
          style={{
            marginTop: 4,
            color: theme.colors.text.danger,
            fontSize: theme.fontSizes.sm,
            fontFamily: theme.form.label.fontFamily,
          }}
        >
          {error}
        </div>
      )}
    </FormLayout>
  );
};

export default TextField;
